import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { Badge } from '@/common/ui/badge'
import { Eye } from 'lucide-react'
import promotionImage from '@/lib/promotion.png'

interface BrokeFlexMessagePreviewProps {
	message: string
	description?: string
	presetName?: string
}

export default function BrokeFlexMessagePreview({
	message,
	presetName,
}: BrokeFlexMessagePreviewProps) {
	return (
		<Card className="sticky top-4 mx-auto max-w-md">
			<CardHeader>
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<Eye className="h-5 w-5 text-muted-foreground" />
						<CardTitle className="text-lg">ตัวอย่างข้อความ</CardTitle>
					</div>
					{presetName && (
						<Badge variant="secondary" className="text-xs">
							{presetName}
						</Badge>
					)}
				</div>
				<p className="mt-1 text-sm text-muted-foreground">
					นี่คือตัวอย่างข้อความที่ผู้เล่นจะเห็นใน LINE
				</p>
			</CardHeader>
			<CardContent className="space-y-4">
				{/* Header message - outside the card */}
				{message && (
					<div className="rounded-xl bg-gradient-to-r from-red-400 to-red-500 p-3 shadow-md">
						<p className="text-center text-sm font-bold leading-relaxed text-white">
							{message}
						</p>
					</div>
				)}

				{/* Flex message card */}
				<div className="overflow-hidden rounded-xl border bg-white shadow-lg">
					{/* Image */}
					<div className="bg-gray-50">
						<img
							src={promotionImage}
							alt="Promotion"
							className="h-auto w-full object-cover"
						/>
					</div>
				</div>

				{/* Helper text */}
				<div className="space-y-2 text-xs text-muted-foreground">
					<p className="flex items-start gap-2">
						<span className="font-bold text-primary">•</span>
						<span>ข้อความจะแสดงในรูปแบบ Carousel (เลื่อนซ้าย-ขวาได้)</span>
					</p>
					<p className="flex items-start gap-2">
						<span className="font-bold text-primary">•</span>
						<span>ระบบจะแสดงเฉพาะรายการที่ผู้เล่นมีสิทธิ์รับเท่านั้น</span>
					</p>
				</div>
			</CardContent>
		</Card>
	)
}
